<template>
<div>
    <v-layout column v-if="!shopLoad" align-center>
        <!-- <v-progress-circular style="margin-top:100px" color="red lighten-3" size="64" indeterminate></v-progress-circular> -->
        <progress-q></progress-q>
    </v-layout>
    <v-layout row>
        <v-flex xs12 sm12 md12 lg8 offset-lg2>
            <v-card v-if="shopLoad" class="dash-card">
                <v-toolbar class="q-orange-bk q-text-whitesmoke">
                    <v-toolbar-title>
                        {{getString('QuickBe Plaza')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-layout row wrap>
                    <v-flex xs12 sm12 md12 lg12>
                        <v-card-text>
                            <v-flex xs12 sm12 md12 lg12>
                                <h3>{{getString('Vuoi attivare QuickBe Plaza?')}}</h3>
                                <label>{{getString(`Attivando Plaza il tuo negozio verrà mostrato nella piattaforma QuickBe Plaza e avrai GRATUITAMENTE un proprio website da mostrare ai tuoi clienti e per farti conoscere`)}}</label>
                                <v-switch :label="getString('Attiva Plaza!')" v-model="options.plazaOn"></v-switch>
                            </v-flex>
                            <v-flex xs12 sm12 md12 lg12 v-if="options.plazaOn === true">
                                <h3 style="margin-bottom:10px;">{{getString('Scegli il template per il tuo sito in Plaza!')}}</h3>
                                <v-select solo color="#212121" v-model="options.plazaTheme" :items="templates" v-bind:label="getString('Scegli il template per il tuo sito Plaza')"></v-select>
                            </v-flex>
                            <v-flex xs12 sm12 md12 lg12 v-if="options.plazaOn === true">
                                <img :src="previewUrl" class="preview">
                            </v-flex>
                            <v-flex xs12 sm12 md12 lg12 style="text-align: center;">
                              <v-tooltip top v-if="oldOptions.plazaOn === true">
                                <h3 slot="activator">{{getString('Ecco il tuo link personale: ')}}<a target="_blank" :href="plazaUrl + options.plazaUrl">{{options.plazaUrl == null ? getString('Verrà generato dopo la pubblicazione del negozio') : options.plazaUrl}}</a></h3>
                                <span>{{getString('Se vuoi modificare il tuo link personale contatta il supporto. Solo per utenti Silver e Platinum')}}</span>
                              </v-tooltip>
                            </v-flex>                            
                        </v-card-text>
                    </v-flex>
                </v-layout>
                <v-card-actions>
                    <v-btn flat color="orange" :class="{'save-alert' : saveAlert}" @click="setShopPlaza">{{getString('Salva')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-flex>
    </v-layout>
</div>
</template>

<script>
import Utils from '../../../utils.js'
import ajax from '../../../ajax.js'
import ProgressQ from '../ProgressQ'
var ut = new Utils()
export default {
  name: 'ShopPlaza',
  props: ['shopID', 'tab'],
  components: {
    ProgressQ
  },
  mounted: function() {
    
    this.getOptions()
  },
  computed: {
    plazaUrl: function() {
      return ajax.plazaUrl
    },
    previewUrl: function(){
      return '../../../static/img/theme'+this.options.plazaTheme+'.png'
    },
    shopLoad: function() {
      return this.loadedOptions === true
    },
    saveAlert: function() {
      if (this.tab !== 6) return false
      let val =
        this.options.plazaOn !== this.oldOptions.plazaOn ||
        this.options.plazaTheme !== this.oldOptions.plazaTheme ||
        this.options.plazaUrl !== this.oldOptions.plazaUrl
      if (val && !this.$store.state.modifying) {
        this.$store.commit('isModifying')
      }
      if (!val && this.$store.state.modifying) {
        this.$store.commit('notIsModifying')
      }
      return val
    }
  },
  data: () => {
    return {
      h: null,
      loadedOptions: false,
      options: {
        plazaOn: true,
        plazaTheme: 0,
        plazaUrl: null
      },
      oldOptions: {
        plazaOn: true,
        plazaTheme: 0,
        plazaUrl: null
      },
      templates: [
        {
          text: 'Day of Autumn',
          value: 0
        },
        {
          text: 'Box',
          value: 1
        },
        {
          text: 'Carriage of barber',
          value: 2
        },
        {
          text: 'Carriage of hairstyle',
          value: 3
        },
        {
          text: 'Wall, photos and carraiges',
          value: 4
        },
        {
          text: 'Le carriages de mauriel',
          value: 5
        },
        {
          text: 'Konnichiwa Kato-San',
          value: 6
        },
        {
          text: 'Marimona\'s Revenge',
          value: 7
        }
      ]
    }
  },
  watch: {
    shopID: function() {
      if (this.shopID > 0) {
        this.getOptions()
      }
    }
  },
  methods: {
    getString: function(key) {
      let page = this.$store.state.currentTranslator.getString(key)
      return page
    },
    getOptions: function() {
      let self = this
      if (self.shopID > 0) {
        ajax.axios
          .get(
            ajax.baseUrl() + '/admin/shops/shop/' + self.shopID + '/options',
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true
            }
          )
          .then(function(response) {
            ajax.validateToken(response.headers,self.$store)
            self.options = response.data.data
            self.oldOptions.plazaOn = response.data.data.plazaOn
            self.oldOptions.plazaTheme = response.data.data.plazaTheme
            self.oldOptions.plazaUrl = response.data.data.plazaUrl
            self.loadedOptions = true
          })
          .catch(function(error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router)
            self.$emit(
              'siteAlert',
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            )
          })
      }
    },
    setShopPlaza: function() {
      let self = this
      console.log(self.options.dashboard)
      if (self.shopID > 0) {
        ajax.axios
          .put(
            ajax.baseUrl() + '/admin/shops/shop/' + self.shopID + '/options',
            self.options,
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true
            }
          )
          .then(function(response) {
            ajax.validateToken(response.headers,self.$store)
            self.options = response.data.data
            self.oldOptions.plazaOn = response.data.data.plazaOn
            self.oldOptions.plazaTheme = response.data.data.plazaTheme
            self.oldOptions.plazaUrl = response.data.data.plazaUrl
            self.$emit(
              'siteAlertSuccess',
              self.getString('Configurazione salvata')
            )
          })
          .catch(function(error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router)
            self.$emit(
              'siteAlert',
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            )
          })
      }
    }
  }
}
</script>

<style scoped>
.avatar-img {
  width: 100%;
  max-height: 300px;
  object-fit: cover;
  transition: max-height 0.3s ease-in-out;
}

.avatar-img:hover {
  max-height: 600px;
}

.save-alert {
  animation-name: saveAlertAnimation1 !important;
  animation-timing-function: linear !important;
  animation-duration: 1s !important;
  animation-iteration-count: infinite !important;
}

.preview{
  max-width:300px;
  margin:auto;
}

@keyframes saveAlertAnimation1 {
  0% {
    background-color: transparent;
  }

  50% {
    background-color: bisque;
  }

  100% {
    background-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/backend/pieces/ShopPlaza.vue